<div style="position: relative;"
     [ngStyle]="{'height': appearance.publicArea.header.height+'px',
                 'background-color': appearance.publicArea.header.bgColor,
                 'color': appearance.publicArea.header.fontColor
                }"
     class="horizontal layout center middle">
    <!--
    LEFT SECTION
    -->
    <div class="horizontal layout start middle" style="position: absolute; left: 8px; z-index: 1;">
        <!--
        BURGER MENU
        -->
        <ng-container *ngIf="isMobile">
            <ng-container *ngIf="!['login','reset_password','set_password','sign_up'].includes(routingDataService.currentRoutingNodeId)
                                && securityDataService.cookiePolicyAccepted()">
                <button *ngIf="appearance.publicArea.header.menu.show"
                        mat-icon-button class="rightSidenav_toggle"
                        style="margin-inline-end: 8px;"
                        (click)="canvasLayoutDataService.toggleSidenav1()">
                    <mat-icon>menu</mat-icon>
                </button>
            </ng-container>
        </ng-container>
        <!-- 
        LOGO
        -->
        <app-flipping-logo *ngIf="appearance.publicArea.header.logo.front.show"
                        [height]="isLesserThanXs ? appearance.publicArea.header.logo.front.compact.height+'px' : appearance.publicArea.header.logo.front.regular.height+'px'" 
                        [width]="isLesserThanXs ? appearance.publicArea.header.logo.front.compact.width+'px' : appearance.publicArea.header.logo.front.regular.width+'px'" 
                        [frontImage]="isLesserThanXs ? appearance.publicArea.header.logo.front.compact.src : appearance.publicArea.header.logo.front.regular.src"
                        [frontImageHeight]="isLesserThanXs ? appearance.publicArea.header.logo.front.compact.height+'px' : appearance.publicArea.header.logo.front.regular.height+'px'" 
                        [frontImageWidth]="isLesserThanXs ? appearance.publicArea.header.logo.front.compact.width+'px' : appearance.publicArea.header.logo.front.regular.width+'px'" >
        </app-flipping-logo>
    </div>
    <!--
    RIGHT SECTION
    -->
    <div class="horizontal layout end middle" style="position: absolute; right: 8px; z-index: 1;">
         <!-- 
        CONTACT US BUTTON
        -->
        <div *ngIf="appearance.publicArea.header.contactUs.show" class="layout horizontal center middle">
            <app-button [label]="isXxxs ? 'PROVA!' : 'PRENOTA UNA PROVA!'" primary="true" 
                        (click)="contactUsClick()"
                        [settings]="{padding: !isMobile ? '8px 50px' : '8px', bgColor:'#43aae0'}"></app-button>
        </div>
        <!--
        PROFILE SECTION
        -->
        <div *ngIf="!['login','reset_password','set_password','sign_up'].includes(routingDataService.currentRoutingNodeId)" style="margin-inline-start: 12px;">
            <app-profile-section *ngIf="appearance.publicArea.header.profileSection.show"></app-profile-section>
        </div>
        <!-- <mat-divider [vertical]="true" style="height: 70%; border-color: white; margin: 0 10px;"></mat-divider> -->
        <!-- 
        LANGUAGE CHOOSER
        -->
        <app-language-chooser *ngIf="appearance.publicArea.header.languageChooser.show"
                            [locales]="locales"
                            [fontColor]="appearance.publicArea.header.fontColor">
        </app-language-chooser>
    </div>
    <!--
    MENU
    -->
    <div class="layout horizontal center middle" style="width: 100%; position: absolute; z-index: 0;">
        <ng-container *ngIf="!isMobile">
            <ng-container *ngIf="!['login','reset_password','set_password','sign_up'].includes(routingDataService.currentRoutingNodeId)
                                 && securityDataService.cookiePolicyAccepted()">
                <app-horizontal-menu *ngIf="appearance.publicArea.header.menu.show"
                                     context="public"
                                     [settings]="{mode: appearance.publicArea.header.menu.mode,
                                                  spacing: appearance.publicArea.header.menu.spacing,
                                                  menuItemStyle: {
                                                      fontSize: appearance.publicArea.header.menu.fontSize,
                                                      fontColor: appearance.publicArea.header.menu.fontColor,
                                                      bgColor: appearance.publicArea.header.menu.bgColor,
                                                      borderColor: appearance.publicArea.header.menu.borderColor,
                                                      underlineColor: appearance.publicArea.header.menu.underlineColor
                                                  },
                                                  hoverMenuItemStyle: {
                                                      fontColor: appearance.publicArea.header.menu.hoverItemFontColor,
                                                      bgColor: appearance.publicArea.header.menu.hoverItemBgColor,
                                                      borderColor: appearance.publicArea.header.menu.hoverItemBorderColor,
                                                      underlineColor: appearance.publicArea.header.menu.hoverItemUnderlineColor
                                                  },
                                                  selectedMenuItemStyle: {
                                                      fontColor: appearance.publicArea.header.menu.selectedItemFontColor,
                                                      bgColor: appearance.publicArea.header.menu.selectedItemBgColor,
                                                      borderColor: appearance.publicArea.header.menu.selectedItemBorderColor,
                                                      underlineColor: appearance.publicArea.header.menu.selectedItemUnderlineColor
                                                  }}">
                </app-horizontal-menu>
            </ng-container>
        </ng-container>
    </div>
</div>